module.exports = __webpack_public_path__ + "img/2.40a0ae06.jpg";